<script>
import { Bar } from 'vue-chartjs'

export default {
    name: 'AttendanceBarChart',
    extends: Bar,
    props: ['data'],
    computed: {
        barChartData() {
            return {
                labels: this.data.map(item => item.full_name),
                datasets: [
                {
                    label: 'Present',
                    backgroundColor: '#4caf50',
                    data: this.data.map(item => item.present)
                },
                {
                    label: 'Absent',
                    backgroundColor: '#f44336',
                    data: this.data.map(item => item.absent)
                }
                ]
            }
        },
        chartOptions() {
            return {
                responsive: true,
                maintainAspectRatio: false,
                scales: {
                xAxes: [{ stacked: true }],
                yAxes: [{ stacked: true }]
                }
            }
        }
  },
    mounted() {
        this.renderChart(this.barChartData, this.chartOptions)
    },
    watch: {
        data: {
            deep: true,
            handler() {
            if (this.chart) {
                this.chart.data = this.barChartData;  // Regenerate chart data
                this.chart.update();                    // Refresh chart display
            } else {
                this.renderChart(this.barChartData, this.chartOptions);
            }
            }
        }
    },
}
</script>
